<template>
  <b-card no-body>
    <b-tabs v-model="tabIndex" card>
      <b-tab title="Дашборд" lazy>
        <finance-dashboard />
      </b-tab>
      <b-tab title="Недели" lazy>
        <finance-weeks-list />
      </b-tab>
      <b-tab title="Выплаты" lazy>
        <finance-payouts />
      </b-tab>
      <b-tab title="Окупаемость пакетов" lazy>
        <finance-packs-roi />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import FinanceDashboard from '@/views/finance/FinanceDashboard.vue'
import FinanceWeeksList from '@/views/finance/FinanceWeeksList.vue'
import FinancePayouts from '@/views/finance/FinancePayouts.vue'
import FinancePacksRoi from '@/views/finance/FinancePacksRoi.vue'
import { ref, watch, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import financeStoreModule from '@/views/finance/financeStoreModule'

const TAB_NAMES = ['dashboard', 'weeks', 'payouts', 'packs-roi']
const STORE_MODULE_NAME = 'app-finance'

export default {
  components: {
    BCard, BTabs, BTab, FinanceDashboard, FinanceWeeksList, FinancePayouts, FinancePacksRoi,
  },
  setup(_, { root }) {
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, financeStoreModule)
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const initialTab = TAB_NAMES.indexOf(root.$route.query.tab)
    const tabIndex = ref(initialTab >= 0 ? initialTab : 0)

    watch(tabIndex, value => {
      const name = TAB_NAMES[value]
      if (root.$route.query.tab === name) return
      root.$router.replace({ query: { ...root.$route.query, tab: name } })
    })

    return { tabIndex }
  },
}
</script>
